import { Link } from "react-router-dom";
import { ArrowRight } from "@/components/Icon";
import { Button } from "@/components/ui/button";
import imgTshirts from "@/assets/categories/card-t-shirts.webp";
import imgPolos from "@/assets/categories/card-polos.webp";
import imgSweaters from "@/assets/categories/card-sweaters-en-hoodies.webp";
import imgJassen from "@/assets/categories/card-jassen-en-bodywarmers.webp";
import imgWerk from "@/assets/categories/card-werkkleding.webp";
import imgSport from "@/assets/categories/card-sportkleding.webp";
import imgCaps from "@/assets/categories/card-caps-en-mutsen.webp";
import imgAccessoires from "@/assets/categories/card-accessoires.webp";

const categories = [
  { label: "T-shirts", key: "tshirt", description: "Klassieke en moderne t-shirts in alle kleuren", image: imgTshirts },
  { label: "Polo's", key: "polo", description: "Zakelijke en sportieve polo's", image: imgPolos },
  { label: "Sweaters & Hoodies", key: "sweater", description: "Warme sweaters en hoodies", image: imgSweaters },
  { label: "Jassen & Bodywarmers", key: "jacket", description: "Jassen, softshells en bodywarmers", image: imgJassen },
  { label: "Werkkleding", key: "workwear", description: "Werkbroeken, jassen en veiligheidskleding", image: imgWerk },
  { label: "Sportkleding", key: "sport", description: "Sportshirts, broeken en teamwear", image: imgSport },
  { label: "Caps & Mutsen", key: "headwear", description: "Petten, caps en wintermutsen", image: imgCaps },
  { label: "Accessoires", key: "accessoires", description: "Sjaals, handdoeken, stropdassen en meer", image: imgAccessoires },
];

const Categories = () => (
  <section id="producten" className="py-20 md:py-28 bg-[#fcfcfc]">
    <div className="container">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#0a2933]">
          Ons assortiment
        </h2>
        <p className="text-muted-foreground">
          Meer dan 4.900 producten om te bedrukken of borduren. Van T-shirts tot werkkleding — alles met uw eigen logo.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/producten?cat=${cat.key}`}
            className="group relative rounded-2xl overflow-hidden aspect-[3/4] shadow-lg"
          >
            <img
              src={cat.image}
              alt={cat.label}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              loading="lazy"
              width={600}
              height={800}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground/85 via-foreground/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6">
              <h3 className="text-xl font-bold text-surface-dark-foreground mb-1">{cat.label}</h3>
              <p className="text-sm text-surface-dark-foreground/80">{cat.description}</p>
            </div>
          </Link>
        ))}
      </div>

      <div className="flex justify-center mt-12">
        <Button size="lg" asChild>
          <Link to="/producten">
            Bekijk al onze producten <ArrowRight className="ml-2 w-4 h-4" />
          </Link>
        </Button>
      </div>
    </div>
  </section>
);

export default Categories;
